import React, { Component } from 'react';
import { Grid } from '@progress/kendo-react-grid';
import { filterBy, orderBy } from '@progress/kendo-data-query';

export class CustomKendoGrid extends Component {
    // Flag to check if the component has been mounted
    _isMounted = false;

    constructor(props) {
        super(props);
        this.pageGrid = this.pageGrid.bind(this);
        this.createGridState = this.createGridState.bind(this);
        this.handleDataCallback = this.handleDataCallback.bind(this);
        this.handleDataCallback();

        this.state = this.createGridState(0, 5);
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    pageGrid(e) {
        if(this._isMounted)
            this.setState(this.createGridState(e.page.skip, e.page.take, this.state.filter, this.state.sort));
    }

    createGridState(skip, take, filter, sort) {

        var sort = sort ? sort : [];

        let gridData = this.state
            ? orderBy(filterBy(this.state.data, filter), sort)
            : [];

        return {
            items: gridData.slice(skip, skip + take),
            total: gridData.length,
            skip: skip,
            pageSize: take,
            pageable: this.state ? this.state.pageable : {
                //buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true
            },
            filter: filter,
            sort: sort
        };
    }

    handleDataCallback() {
        this.props.refreshData().then((data) => {
            if(this._isMounted)
                this.setState({ data: data },
                    () => this.setState(this.createGridState(0, 5))
                );
        });
    }

    render() {
        return (
            <Grid
                sortable
                skip={this.state.skip}
                pageSize={this.state.pageSize}
                total={this.state.total}
                onPageChange={this.pageGrid}
                pageable={{
                    info: true,
                    type: 'numeric',
                    pageSizes: true,
                    previousNext: true
                }}
                filter={this.state.filter}
                onFilterChange={(e) => {
                    if(this._isMounted)
                        this.setState(this.createGridState(0, this.state.pageSize, e.filter, this.state.sort));
                }}
                onSortChange={(e) => {
                    if(this._isMounted)
                        this.setState(this.createGridState(0, this.state.pageSize, this.state.filter, e.sort));
                }}
                sort={this.state.sort}
                data={this.state.items}
            >
                {this.props.children}
            </Grid>
        );
    }
}
